import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelItem, DataPanelRow } from '@/ui';
import type { DeviceInfo } from '@/signalr';
import { deviceOsName } from '../model/deviceOs';

export type DeviceInfoDebugPanelProps = {
  deviceInfo: DeviceInfo;
};

export function DeviceInfoDebugPanel({ deviceInfo }: DeviceInfoDebugPanelProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_DeviceInfoHeader')}>
      <DataPanelItem title={t('Incident_InfoPanel_DeviceId')} value={deviceInfo.deviceId ?? undefined} allowCopyToClipboard />

      <DataPanelRow>
        <DataPanelItem title={t('Incident_InfoPanel_Manufacturer')} value={deviceInfo.manufacturer ?? undefined} />
        <DataPanelItem title={t('Incident_InfoPanel_DeviceName')} value={deviceInfo.deviceName ?? undefined} />
      </DataPanelRow>

      <DataPanelRow>
        <DataPanelItem title={t('Incident_InfoPanel_System')} value={deviceOsName(deviceInfo.system)} />
        <DataPanelItem title={t('Incident_InfoPanel_SystemVersion')} value={deviceInfo.systemVersion ?? undefined} />
      </DataPanelRow>
    </DataPanel>
  );
}
